import { AfterViewInit, Component, ElementRef, Input } from "@angular/core";
import { ResultVar, ThemeVar } from "@model";
import { NightModeService } from "@core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
  selector: "app-flame-animation",
  template: "",
  styleUrl: "./flame-animation.component.scss",
})
export class FlameAnimationComponent implements AfterViewInit {
  private _isNightMode = false;

  @Input() resultColor = false;

  constructor(
    private _el: ElementRef,
    private _nightModeService: NightModeService,
  ) {
    this._nightModeService.isNightMode$
      .pipe(takeUntilDestroyed())
      .subscribe((v) => (this._isNightMode = v));
  }

  ngAfterViewInit() {
    let color1 = "";
    let color2 = "";
    let color3 = "";

    if (this.resultColor) {
      color1 = ResultVar.RESULT_100;
      color2 = ResultVar.RESULT_80;
      color3 = ResultVar.RESULT_60;
    } else {
      color1 = this._isNightMode ? ThemeVar.THEME_20 : ThemeVar.THEME_3;
      color2 = this._isNightMode ? ThemeVar.THEME_21 : ThemeVar.THEME_4;
      color3 = this._isNightMode ? ThemeVar.THEME_22 : ThemeVar.THEME_5;
    }
    this._el.nativeElement.style.backgroundImage = `repeating-linear-gradient(-45deg, var(${color1}) 0 10px, var(${color2}) 10px 20px, var(${color3}) 20px 30px, var(${color1}) 30px 30px)`;
  }
}
